<template>
  <div style="padding: 5px 12px;">
    <van-row class="home_banner">
      <van-col span="8" v-if="noticeCard1.display" >
        <img class="bannerImage wave-1" :src="noticeCard1.url" height="90%" alt="" @click="goToPath(noticeCard1.redirectUrl)">
      </van-col>
      <van-col span="8" v-if="noticeCard2.display">
        <img class="bannerImage wave-2" :src="noticeCard2.url" height="90%" alt="" @click="goToPath(noticeCard2.redirectUrl)">
      </van-col>
      <van-col span="8" v-if="noticeCard3.display">
        <img class="bannerImage wave-3" :src="noticeCard3.url" height="90%" alt="" @click="goToPath(noticeCard3.redirectUrl)">
      </van-col>
    </van-row>
  </div>

</template>

<script setup lang="ts">
import { BannerItem, useNavigation } from '@/view/home/supportScript';
import { onMounted, ref } from 'vue'

const { goToPath } = useNavigation()


const noticeCard1 = ref({
  url: '',
  redirectUrl: '',
  display: false
})
const noticeCard2 = ref({
  url: '',
  redirectUrl: '',
  display: false
})
const noticeCard3 = ref({
  url: '',
  redirectUrl: '',
  display: false
})
const props = defineProps<{
  itemData: {
    notice1: BannerItem,
    notice2: BannerItem,
    notice3: BannerItem
  }
}>()

onMounted(() => {
  noticeCard1.value.url = props.itemData.notice1.url
  noticeCard1.value.redirectUrl = props.itemData.notice1.redirectUrl
  noticeCard1.value.display = props.itemData.notice1.display

  noticeCard2.value.url = props.itemData.notice2.url
  noticeCard2.value.redirectUrl = props.itemData.notice2.redirectUrl
  noticeCard2.value.display = props.itemData.notice2.display

  noticeCard3.value.url = props.itemData.notice3.url
  noticeCard3.value.redirectUrl = props.itemData.notice3.redirectUrl
  noticeCard3.value.display = props.itemData.notice3.display
})
</script>
<style scoped>
.home_banner img {
  width: 90%;
  border-radius: 9px;
  padding: 5px;
}

.bannerImage {
  border-radius: 5px;
  background: linear-gradient(180deg, rgb(13, 176, 174) 0%, rgb(0, 86, 85) 30%);
  animation: waveMove 3s ease-in-out infinite;
  display: block;
  margin: 0 auto;
}

.wave-1 {
  animation-delay: 0s;
}

.wave-2 {
  animation-delay: 0.5s; /* Starts slightly later */
}

.wave-3 {
  animation-delay: 1s; /* Starts even later */
}

@keyframes waveMove {
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-5px); /* Adjust this value for a taller/shorter wave */
  }
}
</style>